module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_4.a0ff92dc.pdf";